<script>
    import { GameBuild } from '../../script/_init'
    import { CheckInnerData, ValidationValue } from '../../script/handle/write'
    export let Title, Nickname, Pass, Memo, Test, Build

    $: if ($GameBuild != '') {
        Build = $GameBuild
    }

    let checkData
    CheckInnerData.subscribe(value => { checkData = value})
</script>

<div class='info'>
    <div class="attention">
        <div class="title">※ 참고 및 주의사항</div>
        <ul>
            <li>* 표시가 있는 항목은 <strong>필수 입력 항목</strong>입니다.</li>
            <li>
                문제가 되는 내용 적발시, <strong>강제 삭제!</strong> 예정입니다.
                <ol>
                    <li>테스트 여부 미체크한 테스트 글</li>
                    <li>제목 및 닉네임이 숫자 또는 자음만 있는 경우</li>
                    <li>욕설, 음란성, 정치적 내용</li>
                    <li>기타 문제되는 글</li>
                </ol>
            </li>
            <li>버그 또는 오타가 있는 경우, 제보 부탁드립니다. => (<a href="https://open.kakao.com/me/admin_turtle" rel="noopener noreferrer" target="_blank">제보</a>)</li>
        </ul>
    </div>

    <div class="formGroup">
        
        <!-- 제목 -->
        <div class="form">
            <div class='grid'>
                <label>제목*</label>
                <input
                    type="text"
                    placeholder='20자 이하 입력!'
                    bind:value={Title}
                    on:input={() => {ValidationValue('title')}}
                />
            </div>

            {#if checkData.title != true && checkData.title != ''}
                <div class='issue'>
                    {checkData.title}
                </div>
            {/if}
        </div>
        
        <!-- 닉네임 -->
        <div class="form">
            <div class='grid'>
                <label>닉네임*</label>
                <input
                    type="text"
                    placeholder='20자 이하 입력!'
                    bind:value={Nickname}
                    on:input={() => {ValidationValue('nickname')}}
                />
            </div>

            {#if checkData.nickname != true && checkData.nickname != ''}
                <div class='issue'>
                    {checkData.nickname}
                </div>
            {/if}
        </div>
        
        <!-- 비밀번호 -->
        <div class="form">
            <div class='grid'>
                <label>비밀번호*</label>
                <input
                    type="password"
                    placeholder='20자 이하 입력!'
                    bind:value={Pass}
                    on:input={() => {ValidationValue('pass')}}
                />
            </div>

            {#if checkData.pass != true && checkData.pass != ''}
                <div class='issue'>
                    {checkData.pass}
                </div>
            {/if}
        </div>

        <!-- 메모 -->
        <div class="form">
            <div class='grid'>
                <label>메모</label>
                <textarea
                    style="height:100px;"
                    placeholder='메모 입력'
                    bind:value={Memo}
                ></textarea>
            </div>
        </div>

        <!-- 테스트 -->
        <div class="form">
            <div class='grid'>
                <label>테스트 여부</label>
                <input type="checkbox" bind:checked={Test} />
            </div>
        </div>

        <!-- 버전 -->
        <div class="form">
            <div class='grid'>
                <label>버전</label>
                <input
                    type="text"
                    bind:value={Build}
                    disabled
                />
            </div>
        </div>
    </div>
</div>

<style lang="scss">
    .info {
        width: 100%;
        height: fit-content;

        .attention {
            background: rgba($color: $cl3, $alpha: 0.3);
            width: calc(100% - 20px);
            height: fit-content;
            padding: 30px 10px;

            .title {
                color: $cl4;
                font-size: 15px;
                font-family: aggro;
            }

            ul, ol {
                margin: 0px;
                padding-left: 25px;
                font-size: 15px;

                li {
                    margin: 5px 0px;
                    word-break: keep-all;
                }

                a {
                    padding: 4px;
                    border-radius: $br1;
                    color: $cl4;
                    font-family: aggro;

                    &:hover {
                        background: $cl5;
                        color: $cl2;
                    }
                }
            }
        }

        .formGroup {
            width: calc(100% - 20px);
            height: fit-content;
            margin: 50px 10px;

            .form {
                width: calc(100% - 20px);
                height: fit-content;
                margin-bottom: 20px;

                .grid {
                    width: 100%;
                    height: fit-content;
                    display: grid;
                    grid-template-columns: 100px calc(100% - 100px - 10px);
                    grid-column-gap: 10px;

                    label {
                        padding: 2px;
                        font-size: 16px;
                        vertical-align: middle;
                    }
                    input {
                        margin: 0px;
                        vertical-align: middle;
                        &[type=checkbox] {
                            width: 21px;
                            height: 21px;
                            margin: 2px 0;
                            cursor: pointer;
                        }

                        &:disabled { color: $cl2; }
                    }
                        
                }
                .issue {
                    margin-top: 10px;
                    margin-left: calc(25% + 10px);
                    color: $cl4;
                    font-size: 12px;
                    font-family: aggro;
                }
            }
        }
    }
</style>